/* eslint-disable */
import { Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generatePDF } from '../../utils';
import PropTypes from 'prop-types';
import Image from '../../components/DynamicImages';
import { useTheme } from '@emotion/react';

const ViewStove = ({ kitchen }) => {
  const [save, setSave] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const parentPath = location.pathname.split('/')[1];

  // Breakpoints for PDF Generation
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('lg'));
  const tablet = useMediaQuery(theme.breakpoints.up('sm'));
  const mobile = useMediaQuery(theme.breakpoints.up('xs'));

  const sizes = () => {
    if (desktop) return [-140, 0];
    if (tablet) return [-140, 0];
    if (mobile) return [-110, 0];
  };

  const loadConfiguredImage = (configuredAppliance) => {
    const { src, positioning } = configuredAppliance || {};

    return (
      <>
        {src?.length > 0 &&
          src?.map((el) => (
            <Image
              key={el}
              classes="childImageBox"
              style={{
                left: positioning?.[0],
                top: positioning?.[1],
              }}
              name={el}
            />
          ))}
      </>
    );
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      maxWidth="lg"
      marginLeft="auto"
      marginRight="auto"
      className="VisualizerMainContainer"
    >
      <Grid item xs={12}>
        <Box className="VisualizerHeading">
          <Typography variant="h1" textAlign="center">
            VIEW YOUR COMPLETED STOVE AND PRICING
          </Typography>
          <Typography variant="h6" textAlign="center">
            {`${parentPath.toUpperCase()} STOVE`}
          </Typography>
        </Box>
        <Box textAlign="center" data-html2canvas-ignore="true">
          <>
            <Button
              variant="Button"
              className="SavePdfBtn"
              disabled={save}
              onClick={() => {
                setSave(true);
                generatePDF(parentPath, '', sizes, setSave);
              }}
            >
              {!save ? 'SAVE AS PDF' : 'Saving...'}
            </Button>
            <Button
              variant="Button"
              onClick={() => navigate('range/product-studio')}
              className="ResetBtn"
            >
              CONFIGURE STOVE
            </Button>
          </>
        </Box>
      </Grid>
      <Box className="FireviewVisualizer">
        <div className="StoveFirstChild"></div>
        {kitchen?.appliancesSrc?.length > 0 &&
          kitchen?.appliancesSrc?.map((configuredAppliance) =>
            loadConfiguredImage(configuredAppliance),
          )}
      </Box>
    </Grid>
  );
};

ViewStove.propTypes = {
  kitchen: PropTypes.object.isRequired,
};

export default ViewStove;
